import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { activateAgentFailure, activateAgentStart, activateAgentSuccess, addAgentFailure, addAgentStart, addAgentSuccess, getAgentsFailure, getAgentsStart, getAgentsSuccess, updateAgentFailure, updateAgentStart, updateAgentSuccess } from './AgentActions'


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getAgents = async(dispatch, pageSize, page, type, username, idWilaya, idCommune, nom, agence)=>{
    let agentFilter = {username, type, wilaya: idWilaya, commune: idCommune, nom, agence};
    dispatch(getAgentsStart());
    try{
        const res = await axiosInstance.post(`/admin/agents?pageSize=${pageSize}&page=${page}`,agentFilter,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getAgentsSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getAgentsFailure(err.response.data.message))
        }else{
            dispatch(getAgentsFailure("Unkown Error"))
        }
    }
}

export const addAgent = async(dispatch, type, agence, username, password, idWilaya, idCommune, nom, email, tel1, tel2)=>{
    let agent = {type, agence, username, password, wilaya:idWilaya, commune:idCommune, nom, email, tel1, tel2};
    dispatch(addAgentStart())
    try{
        const res = await axiosInstance.post(`/admin/agents/add`,agent,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addAgentSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(addAgentFailure(err.response.data.message))
        }else{
            dispatch(addAgentFailure("Unkown Error"))
        }
    }
}

export const updateAgent = async(dispatch,id, type, agence, username, password, idWilaya, idCommune, nom, email, tel1, tel2)=>{
    let agent = {type, agence, username, password, wilaya:idWilaya, commune:idCommune, nom, email, tel1, tel2};
    dispatch(updateAgentStart())
    try{
        const res = await axiosInstance.put(`/admin/agents/update/${id}`,agent,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateAgentSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(updateAgentFailure(err.response.data.message))
        }else{
            dispatch(updateAgentFailure("Unkown Error"))
        }
    }
}

export const ToggleActiveAgent = async(dispatch,agentId)=>{
    dispatch(activateAgentStart())
    try{
        const res = await axiosInstance.post(`/admin/agents/active`,{id: agentId},{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(activateAgentSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(activateAgentFailure(err.response.data.message))
        }else{
            dispatch(activateAgentFailure("Unkown Error"))
        }
    }
}

